module.exports = __webpack_public_path__ + "r-v3/img/arrowRight_white.16879852.svg";